import * as LoginTypes from 'src/actions/authentication/login/Types';
import * as RegisterTypes from 'src/actions/authentication/register/Types';
import * as PasswordRecoveryTypes from 'src/actions/authentication/password-recovery/Types';
import Token from 'src/value-objects/Token';
import { LoginAction, LoginSuccess } from 'src/actions/authentication/login/Login.actions';
import { RegisterAction, RegisterSuccess } from 'src/actions/authentication/register/Register.actions';
import * as jwtDecode from 'jwt-decode';
import { PasswordRecoveryAction } from 'src/actions/authentication/password-recovery/PasswordRecovery.actions';

export interface AuthenticationState {
  token: Token | null;
  loading: boolean;
  loginError: boolean;
  registerError: boolean;
  errorMessage: {};
  passwordRecoveryError: {};
  isLogged: boolean;
  loggedUserData: number | null;
}

const initialState: AuthenticationState = {
  token: null,
  loading: false,
  loginError: false,
  registerError: false,
  passwordRecoveryError: {},
  errorMessage: {},
  isLogged: false,
  loggedUserData: null,
};

const loginUserDataKey: string = 'sub';

export function AuthenticationReducer(
  state: AuthenticationState = initialState,
  action: LoginAction | RegisterAction | PasswordRecoveryAction
): AuthenticationState {
  switch (action.type) {
    case LoginTypes.LOGOUT:
      return { ...state, token: null, loading: false, loginError: false, isLogged: false, loggedUserData: null };
    case LoginTypes.LOGIN_ATTEMPT:
      return { ...state, loading: true, loginError: false };
    case LoginTypes.LOGIN_SUCCESS:
      const token: Token = (action as LoginSuccess).payload;
      const loginUserData = (jwtDecode(token.value) as Object)[loginUserDataKey];
      return { 
        ...state,
        token: token,
        loading: false,
        loginError: false,
        isLogged: true,
        loggedUserData: loginUserData };
    case LoginTypes.LOGIN_FAILURE:
      return { ...state, loading: false, loginError: true, errorMessage: action.payload };
    case LoginTypes.LOGIN_CLEAR_ERRORS:
      return { ...state, loading: false, loginError: false, errorMessage: {} };
    case RegisterTypes.REGISTER_ATTEMPT:
      return { ...state, loading: true, registerError: false };
    case RegisterTypes.REGISTER_SUCCESS:
      const registerToken: Token = (action as RegisterSuccess).payload;
      const registerUserData = (jwtDecode(registerToken.value) as Object)[loginUserDataKey];
      return {
        ...state,
        token: registerToken,
        loading: false,
        registerError: false,
        isLogged: true,
        loggedUserData: registerUserData
      };
    case RegisterTypes.REGISTER_FAILURE:
      return { ...state, loading: false, registerError: true, errorMessage: action.payload };
    case RegisterTypes.REGISTER_CLEAR_ERRORS:
      return { ...state, loading: false, registerError: false, errorMessage: {} };
    case PasswordRecoveryTypes.PASSWORD_RECOVERY_ATTEMPT:
      return { ...state, loading: true };
    case PasswordRecoveryTypes.PASSWORD_RECOVERY_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case PasswordRecoveryTypes.PASSWORD_RECOVERY_FAILURE:
      return { ...state, loading: false, passwordRecoveryError: action.payload };
    case PasswordRecoveryTypes.PASSWORD_RECOVERY_CLEAR_ERRORS:
      return { ...state, loading: false, passwordRecoveryError: {} };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AuthenticationReducer.tsx